import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import {GlobalService} from '../shared/services/global.service';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class HomeComponent implements OnInit {
	loading: boolean = false;
	pages:any = this._gS.home_pages.slice(1,this._gS.home_pages.length)

   constructor(public _gS:GlobalService) { }

  ngOnInit() {
  }

}
